/**
 * Calculate previous period date range.
 * If current = Apr 3 - Apr 16 (14 days), previous = Mar 20 - Apr 2.
 */
export function getPreviousPeriod(dateFrom: string, dateTo: string) {
  const from = new Date(dateFrom);
  const to = new Date(dateTo);
  const days = Math.round((to.getTime() - from.getTime()) / 86400000);

  const prevTo = new Date(from);
  prevTo.setDate(prevTo.getDate() - 1);
  const prevFrom = new Date(prevTo);
  prevFrom.setDate(prevFrom.getDate() - days);

  return {
    dateFrom: prevFrom.toISOString().split("T")[0],
    dateTo: prevTo.toISOString().split("T")[0],
  };
}
